<template>
  <div class="sticky bottom-0 left-0 w-full">
    <div class="card-shadow bg-background-neutral-secondary rounded-t-2xl p-4">
      <div class="flex flex-col gap-3">
        <FreeButton
          type="button"
          class="green-main-button w-full"
          :disabled="isActualizing || isError"
          @click="
            buttonText === t('general.save') ? emit('onDelete') : emit('onSave')
          "
        >
          {{ buttonText }}
        </FreeButton>
        <i18n-t
          tag="p"
          class="text-text-neutral-primary text-center text-sm"
          keypath="ancillaries.flightDelay.offer.content"
        >
          <template #personalData>
            <button
              class="text-text-positive-primary"
              type="button"
              @click="
                openInsuranceDocument(
                  appConfig.isDevRuntimeEnv,
                  medicalInsuranceConfig.PERSONAL_DATA_LINK,
                )
              "
            >
              {{ t('ancillaries.medicalInsurance.offer.personalData') }}
            </button>
          </template>
          <template #publicOffer>
            <button
              type="button"
              class="text-text-positive-primary"
              @click="
                bottomSheet.show(
                  medicalInsuranceConfig.PUBLIC_OFFER_BOTTOM_SHEET,
                )
              "
            >
              {{ t('ancillaries.medicalInsurance.offer.publicOffer') }}
            </button>
          </template>
          <template #agreement>
            <button
              class="text-text-positive-primary"
              type="button"
              @click="
                openInsuranceDocument(
                  appConfig.isDevRuntimeEnv,
                  flightDelayConfig.RULES_FILE_LINK,
                )
              "
            >
              {{ t('ancillaries.medicalInsurance.offer.agreement') }}
            </button>
          </template>
        </i18n-t>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import { FreeButton } from 'freedom-shared';
  import { controllerModel, openInsuranceDocument } from 'shared';

  import { medicalInsuranceConfig } from '@/widgets/medical-insurance';
  import { flightDelayConfig } from '@/widgets/flight-delay';

  import { appConfig } from '@/shared/config';

  defineProps<{
    totalAmount: number;
    buttonText: string;
    isActualizing?: boolean;
    isError?: boolean;
  }>();

  const emit = defineEmits<{
    onSave: [];
    onDelete: [];
  }>();

  const { t } = useI18n();
  const bottomSheet = controllerModel.useBottomSheet();
</script>
